// 活动信息
const EventCode = 240522;

export const EventInfo = {
    // 活动基本信息
    eventCode: EventCode,
    bannerLinks: [{
        name: "排行榜",
        link: "https://ix.icode.org.cn/rankBoard?eventCode=" + EventCode,
        show: true,
    }, {
        name: "ICode学习平台",
        link: "https://home.icode.org.cn",
        show: true,
    }],
    eventGameList: [{
        name: "图形化小学组", // 组别名称
        id: 24052201, // 比赛ID
        mode: 0, // 比赛模式：0-积木，1-Python
        minGrade: 1, // 组别最低年级（包含，1-12）
        maxGrade: 6 // 组别最高年级（包含，1-12）
    },{
        name: "图形化初中组", // 组别名称
        id: 24052202, // 比赛ID
        mode: 0, // 比赛模式：0-积木，1-Python
        minGrade: 7, // 组别最低年级（包含，1-12）
        maxGrade: 9 // 组别最高年级（包含，1-12）
    }, {
        name: "Python小学组",
        id: 24052211,
        mode: 1,
        minGrade: 1,
        maxGrade: 6
    }, {
        name: "Python中学组",
        id: 24052212,
        mode: 1,
        minGrade: 7,
        maxGrade: 12
    }
    ],

    orgList: [
        "主办单位：中国电子学会",
        "战略合作单位：深圳市腾讯计算机系统有限公司",
        "技术支持：立乐教育科技（上海）有限公司"
    ]
}


// WEBPACK FOOTER //
// ./src/components/contest/wrc_learn/eventConfig.js